const PAYMENTS = [
  { n: 1, label: "CASH", method: "CASH", type: "cash" },
  { n: 2, label: "PINELAB", method: "PINELAB", type: "edc" },
  { n: 3, label: "Pay credit", method: "PAY CREDIT", type: "credit" },
  { n: 4, label: "PAYTM CARD", method: "PAYTM CARD", type: "edc" },
  { n: 5, label: "COUPON-GIFT", method: "COUPON-GIFT", type: "coupon" },
  { n: 6, label: "UPI", method: "UPI", type: "edc" },
  { n: 7, label: "PAYTM UPI", method: "PAYTM UPI", type: "edc" },
  { n: 8, label: "PINE CLD UPI", method: "PINE CLD UPI", type: "edc" },
  { n: 9, label: "AMAZON UPI", method: "AMAZON UPI", type: "edc" },
  { n: 10, label: "PINE CLD CARD", method: "PINE CLD CARD", type: "edc", hot: true },
];

export function PaymentGrid({ onPay }) {
  return (
    <div className="pay-grid" data-testid="payment-grid">
      {PAYMENTS.map((p) => (
        <div
          key={p.n}
          className={`pay-cell ${p.hot ? "hot" : ""}`}
          onClick={() => onPay(p)}
          data-testid={`pay-${p.method.replace(/\s+/g, "-").toLowerCase()}`}
        >
          <span className="num">{p.n}.</span>
          {p.label}
        </div>
      ))}
    </div>
  );
}

export { PAYMENTS };
